export default "<div>\r\n  <div class=\"project-header\">\r\n    <h1>{{selectedProject.name}}</h1>\r\n  </div>\r\n</div>"